import { FC } from 'react';
import { StampDutyWrapper } from './StampDutyWrapper/StampDutyWrapper';
import { ValidNode } from '../../../types';

export type Props = {
    node: ValidNode;
};
export const ReactComponentEntry: FC<Props> = ({ node }) => {
    const { title, body, componentName } = node.data.target.fields || {};

    switch (componentName) {
        case 'Stamp Duty Calculator':
            return <StampDutyWrapper title={title} body={body} />;

        // add more wrappers here!

        default:
            return <>Component not updated yet</>;
    }
};
